<template>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#services_settings" role="tab"
                           aria-selected="false">
                            {{ $t('application.services_settings') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#providers_settings" role="tab"
                           aria-selected="false">
                            {{ $t('application.providers_settings') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#open-banking-wallet-settings" role="tab"
                           aria-selected="false">
                            {{ $t('open_banking_wallet.settings') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#open-banking-tax-settings" role="tab"
                           aria-selected="false">
                            {{ $t('application.tax_settings') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#open-banking-withdrawal-limits-settings" role="tab"
                           aria-selected="false">
                            {{ $t('application.withdrawal_limits_settings') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div class="tab-pane active" id="services_settings"
                     v-if="services_settings">
                    <services-settings :settings="services_settings"
                                       :service_bank_providers="service_bank_providers"></services-settings>
                </div>
                <div class="tab-pane" id="providers_settings"
                     v-if="providers_settings">
                    <providers-settings :settings="providers_settings"
                                        :service_bank_providers="service_bank_providers"></providers-settings>
                </div>
                <div class="tab-pane" id="open-banking-wallet-settings">
                    <open-banking-wallet-settings></open-banking-wallet-settings>
                </div>
                <div class="tab-pane" id="open-banking-tax-settings">
                    <tax-settings></tax-settings>
                </div>
                <div class="tab-pane" id="open-banking-withdrawal-limits-settings">
                    <bank-withdrawal-limits-settings></bank-withdrawal-limits-settings>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</template>

<script>


import ServicesSettings from './services-settings'
import ProvidersSettings from './providers-settings'
import {openBankingService} from "@/common/api.service";
import toastr from "toastr";
import OpenBankingWalletSettings from './OpenBankingWalletSettings'
import TaxSettings from './TaxSettings.vue'
import BankWithdrawalLimitsSettings from './BankWithdrawalLimitsSettings.vue'

export default {
    components: {
        'services-settings': ServicesSettings,
        'providers-settings': ProvidersSettings,
        'open-banking-wallet-settings': OpenBankingWalletSettings,
        'tax-settings': TaxSettings,
        'bank-withdrawal-limits-settings': BankWithdrawalLimitsSettings
    },
    data() {
        return {
            services_settings: null,
            providers_settings: null,
            service_bank_providers: null,
        }
    },
    mounted() {
        openBankingService.adminGetSettings().then(response => {
            this.services_settings = response.data.data.service_default_provider;
            this.providers_settings = response.data.data.provider_services_price_settings;
            this.service_bank_providers = response.data.data.service_bank_providers;
        });
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
}
</script>

<style>

</style>